import { PublicSignaturePages } from '@greenkub-fronts/pages/signature-pages';
import { AreaCustomerPage } from '@greenkub-fronts/pages/customer-area';

interface RouterProps {
  path: string;
  component: React.ReactElement | JSX.Element | any;
  protected: boolean;
  layout: boolean;
}

export const ROUTER: RouterProps[] = [
  // SIGNATURE DE DOCUMENT EXISTANT (PDF)
  {
    path: 'signature/sign/*',
    component: <PublicSignaturePages />,
    protected: false,
    layout: false,
  },
  // CUSTOMER PAGE
  {
    path: '*',
    component: <AreaCustomerPage />,
    protected: true,
    layout: true,
  },
];
